module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "topictitle1",
    attrs: {
      "id": "ep2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav#nep2"
    }
  }, [_c('span', {
    staticClass: "first_text"
  }, [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('div', {
    staticClass: "epi_group"
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Socially inept, I was—like most of my friends, driven mostly by a child-like sense of wonder about the world. We were beat\n               over the heads for our strange ideas—told that the answers we sought from nature were impossibilities . . . that we must put\n               away childish thoughts, and curiosity, and “grow up.” Some of us resisted. We never did finish growing up. But we never stopped\n               growing.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph_attribution"
  }, [_vm._v("—Sir Arthur C. Clarke")]), _vm._v(" "), _c('p', {
    staticClass: "sep"
  }), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("It’s kind of fun to do the impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph_attribution"
  }, [_vm._v("—Walt Disney")]), _vm._v(" "), _c('p', {
    staticClass: "sep"
  }), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("1N73LL1G3NC3 15 7H3 4B1L17Y 70 4D4P7 70 CH4NG3.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph_attribution"
  }, [_vm._v("—573PH3N H4WK1NG")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226c2c02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epigraph.vue
// module id = 66
// module chunks = 0